import React from "react";
import parse from "html-react-parser";
import { Error } from "../../common/icons";

function ErrorComponent({ errorMessage }) {
  console.error("errorMessage", errorMessage);
  return (
    <div className="validation-error p-3">
      <div className="mr-2">
        <Error />
      </div>
      <div> {parse(errorMessage)} </div>
    </div>
  );
}

export default ErrorComponent;
